function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M12 5.25L12 8.25",
  stroke: "#1B1C1C",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 12H1.5M4.5 9H1.5M4.5 6H1.5M9 16.5C6.8998 16.5 5.8497 16.5 5.04754 16.0913C4.34193 15.7317 3.76825 15.1581 3.40873 14.4525C3 13.6503 3 12.6002 3 10.5V7.5C3 5.3998 3 4.3497 3.40873 3.54754C3.76825 2.84193 4.34193 2.26825 5.04754 1.90873C5.8497 1.5 6.8998 1.5 9 1.5C11.1002 1.5 12.1503 1.5 12.9525 1.90873C13.6581 2.26825 14.2317 2.84193 14.5913 3.54754C15 4.3497 15 5.3998 15 7.5V10.5C15 12.6002 15 13.6503 14.5913 14.4525C14.2317 15.1581 13.6581 15.7317 12.9525 16.0913C12.1503 16.5 11.1002 16.5 9 16.5Z",
  stroke: "#54606B",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcNotebookHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotebookHome);
export default __webpack_public_path__ + "static/media/ic_notebook_home.891dd626.svg";
export { ForwardRef as ReactComponent };